import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setColorAll } from '../../store/modules/colorplate';
import langList from '../../utils/languagelist.json'

export default function Coloritem(p) {
  const { nu }=p
  const {...colorvalue}=useSelector((state)=>state.colorplate);
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();

  const [selectedColor, setSelectedColor] = useState(colorvalue[nu]);
  
  const handleClick = () => {
    colorvalue[nu] = selectedColor;
    dispatch(setColorAll(colorvalue))
    localStorage.setItem('color', JSON.stringify(colorvalue));
  }

  return (
    <div className='d-flex justify-content-between'>
      <Form.Control
        type="color"
        id="ColorInput"
        defaultValue={selectedColor}
        onChange={e=>setSelectedColor(e.target.value)}
      />
      <Button variant="outline-primary" size="sm" onClick={handleClick}>{langList.public7[lg]}</Button>
    </div>
  )
};

